document.addEventListener("DOMContentLoaded", () => {
    const stickyMenus = document.querySelectorAll(".js-menu-sticky-below-header");
    if (!stickyMenus.length) return;

    const body = document.body;
    const header = document.querySelector(".header");

    const updateMenuStickyState = () => {
        const isHeaderSticky = body.classList.contains("sticky-menu");
        const headerHeight = header ? header.getBoundingClientRect().height : 0;

        stickyMenus.forEach((menu) => {
            if (!menu.dataset.originalHeight) {
                menu.dataset.originalHeight = String(menu.offsetHeight || 0);
            }

            if (isHeaderSticky) {
                menu.classList.add("is-sticky-below-header-active");
                menu.style.setProperty("--menu-sticky-top", `${headerHeight}px`);
                menu.style.height = `${menu.dataset.originalHeight}px`;
            } else {
                menu.classList.remove("is-sticky-below-header-active");
                menu.style.removeProperty("--menu-sticky-top");
                menu.style.removeProperty("height");
            }
        });
    };

    const recalcHeights = () => {
        stickyMenus.forEach((menu) => {
            const wasActive = menu.classList.contains("is-sticky-below-header-active");
            if (wasActive) {
                menu.classList.remove("is-sticky-below-header-active");
                menu.style.removeProperty("height");
            }
            menu.dataset.originalHeight = String(menu.offsetHeight || 0);
            if (wasActive) {
                menu.classList.add("is-sticky-below-header-active");
                menu.style.height = `${menu.dataset.originalHeight}px`;
            }
        });

        updateMenuStickyState();
    };

    updateMenuStickyState();
    window.addEventListener("scroll", updateMenuStickyState, { passive: true });
    window.addEventListener("resize", recalcHeights);
});
